import React from "react";
import flightLoader from "../../../../assets/media/hotel-loader.gif";
import hotelLogo from "../../../../assets/media/Holidays.json";
import Lottie from "lottie-react";

export const Loader = ({mainLoading = false , isDetail = false}) => {
  return (
    <div className="hw-before-loader--status hotel" style={isDetail ? {position:"absolute",zIndex:"9"} : {}}>
      <div
        className="hotel-loader"
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* <img src={flightLoader} alt="flight=loader" width="110" /> */}
        <Lottie
          animationData={hotelLogo}
          loop={true}
          style={{ width: 110, height: 110 }}
        />
      </div>
      <div className="hw-loader--text">{`Hold On, We're Fetching ${isDetail ? "Details" : "Hotels"} For You...`}</div>
    </div>
  );
};